export default "__VITE_ASSET__CUft9_mv__"